//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImportLogConfig
export const EmployeeFundsImportLogConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/ewa/importLogs',
      component: FuseLoadable({
          loader: () => import('./ImportLogs')
      })
  }
  ]
  //end routes
};
